export default __webpack_public_path__ + "static/media/about_background2.0bd38bda.jpg";